import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-i18n-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import { Translator, TextFallbackHook as Text } from "./components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Translator heading page="fallbackHook" num="0" mdxType="Translator" />
    <Translator page="fallbackHook" num="0" mdxType="Translator" />
    <Translator page="fallbackHook" num="1" mdxType="Translator" />
    <Translator page="fallbackHook" num="2" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// ./i18n/index.js
const data = {
  de: {
    text: "Hallo Welt!",
  },
  en: {
    text: "Hello World!",
  },
  es: {
    text: "!Hola Mundo!",
  },
};

export { data };
`}</code></pre>
    <Translator page="fallbackHook" num="3" mdxType="Translator" />
    <Translator page="fallbackHook" num="4" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { data } from './i18n';
import { useI18n } from '../../../src';

const TextFallbackHook = (props) => {
  /*
    Never set a language you do not have a translation for.
    We just use it as example, so you can see the fallback in your browser.
  */
  const { i18n } = useI18n(data, { lang: 'zh', fallback: 'es' });

  return (
    <div>
      {i18n.text}
    </div>
  );
};

export { TextFallbackHook as Text };
`}</code></pre>
    <Translator page="fallbackHook" num="5" mdxType="Translator" />
    <Playground __position={7} __code={'<Text />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Translator,
      Text
    }} mdxType="Playground">
  <Text mdxType="Text" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      